import {combineReducers} from '@reduxjs/toolkit';

import {assignedUsersSlice} from './slices/assigned-users-slice';
import {assignedUsersStateSlice} from './slices/assigned-users-state-slice';

export const assignedUsersReducer = combineReducers({
    result: assignedUsersSlice.reducer,
    state: assignedUsersStateSlice.reducer,
});
